module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/G+P大型センサーOISカメラ.4f17aac3.png";